// shop-page.js
class ShopPage {
  constructor() {
    this.grid = document.getElementById('ProductGrid');
    this.sortSelect = document.getElementById('sort-by');
    this.collectionCheckboxes = document.querySelectorAll('.collection-checkbox');
    this.priceSortRadios = document.querySelectorAll('.price-sort-radio');
    this.priceInputs = document.querySelectorAll('.price-input');
    this.priceSliders = document.querySelectorAll('.price-slider-input');
    this.resetBtn = document.querySelector('.reset-filters');
    this.applyPriceBtn = document.querySelector('.apply-price-filter');
    
    this.currentPage = 1;
    this.filters = {
      collections: [],
      priceMin: null,
      priceMax: null,
      sortBy: 'created-descending'
    };
    
    this.init();
  }
  
  init() {
    this.bindEvents();
    this.updatePriceSlider();
  }
  
  bindEvents() {
    // Sort select change
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => {
        this.filters.sortBy = e.target.value;
        this.loadProducts();
      });
    }
    
    // Collection checkboxes
    this.collectionCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (e) => {
        this.updateCollectionFilters();
        this.loadProducts();
      });
    });
    
    // Price sort radios
    this.priceSortRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        this.filters.sortBy = e.target.value;
        this.loadProducts();
      });
    });
    
    // Price inputs
    this.priceInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        this.filters.priceMin = document.getElementById('price-min').value || null;
        this.filters.priceMax = document.getElementById('price-max').value || null;
      });
    });
    
    // Apply price filter
    if (this.applyPriceBtn) {
      this.applyPriceBtn.addEventListener('click', () => {
        this.loadProducts();
      });
    }
    
    // Reset filters
    if (this.resetBtn) {
      this.resetBtn.addEventListener('click', () => {
        this.resetFilters();
      });
    }
    
    // Price sliders
    this.priceSliders.forEach(slider => {
      slider.addEventListener('input', (e) => {
        this.updatePriceFromSlider();
      });
    });
    
    // Pagination clicks (if using standard pagination)
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('pagination__link')) {
        e.preventDefault();
        const page = e.target.getAttribute('data-page');
        this.loadProducts(page);
      }
    });
  }
  
  updateCollectionFilters() {
    this.filters.collections = [];
    this.collectionCheckboxes.forEach(checkbox => {
      if (checkbox.checked) {
        this.filters.collections.push(checkbox.value);
      }
    });
  }
  
  updatePriceSlider() {
    // Update input values when sliders change
    if (this.priceSliders.length >= 2) {
      const minSlider = this.priceSliders[0];
      const maxSlider = this.priceSliders[1];
      const minInput = document.getElementById('price-min');
      const maxInput = document.getElementById('price-max');
      
      if (minInput && maxInput) {
        minSlider.addEventListener('input', () => {
          minInput.value = minSlider.value;
        });
        
        maxSlider.addEventListener('input', () => {
          maxInput.value = maxSlider.value;
        });
      }
    }
  }
  
  updatePriceFromSlider() {
    if (this.priceSliders.length >= 2) {
      this.filters.priceMin = this.priceSliders[0].value;
      this.filters.priceMax = this.priceSliders[1].value;
    }
  }
  
  resetFilters() {
    // Reset checkboxes
    this.collectionCheckboxes.forEach(checkbox => {
      checkbox.checked = false;
    });
    
    // Reset price inputs
    document.getElementById('price-min').value = '';
    document.getElementById('price-max').value = '';
    
    // Reset price sliders
    if (this.priceSliders.length >= 2) {
      this.priceSliders[0].value = 0;
      this.priceSliders[1].value = 1000;
    }
    
    // Reset sort
    this.sortSelect.value = 'created-descending';
    this.filters = {
      collections: [],
      priceMin: null,
      priceMax: null,
      sortBy: 'created-descending'
    };
    
    this.loadProducts();
  }
  
  async loadProducts(page = 1) {
    this.showLoading();
    this.currentPage = page;
    
    try {
      const url = this.buildUrl(page);
      const response = await fetch(url);
      const html = await response.text();
      
      // Parse the response to extract products grid
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('#ProductGrid');
      
      if (newGrid) {
        this.grid.innerHTML = newGrid.innerHTML;
        this.updateURL();
      }
      
      // Update pagination
      const newPagination = doc.querySelector('.pagination-container');
      const currentPagination = document.querySelector('.pagination-container');
      if (newPagination && currentPagination) {
        currentPagination.innerHTML = newPagination.innerHTML;
      }
      
    } catch (error) {
      console.error('Error loading products:', error);
    } finally {
      this.hideLoading();
    }
  }
  
  buildUrl(page) {
    let url = `${window.collectionData.url}?page=${page}&view=shop-page`;
    
    // Add sort parameter
    url += `&sort_by=${this.filters.sortBy}`;
    
    // Add collection filters
    if (this.filters.collections.length > 0) {
      url += `&constraint=${this.filters.collections.join(',')}`;
    }
    
    // Add price filter
    if (this.filters.priceMin || this.filters.priceMax) {
      url += `&filter.v.price.gte=${this.filters.priceMin || 0}`;
      url += `&filter.v.price.lte=${this.filters.priceMax || 100000}`;
    }
    
    return url;
  }
  
  updateURL() {
    const url = new URL(window.location);
    url.searchParams.set('sort_by', this.filters.sortBy);
    
    // Update collections in URL
    if (this.filters.collections.length > 0) {
      url.searchParams.set('constraint', this.filters.collections.join(','));
    } else {
      url.searchParams.delete('constraint');
    }
    
    // Update price in URL
    if (this.filters.priceMin) {
      url.searchParams.set('price_min', this.filters.priceMin);
    } else {
      url.searchParams.delete('price_min');
    }
    
    if (this.filters.priceMax) {
      url.searchParams.set('price_max', this.filters.priceMax);
    } else {
      url.searchParams.delete('price_max');
    }
    
    window.history.replaceState({}, '', url.toString());
  }
  
  showLoading() {
    let overlay = document.querySelector('.loading-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'loading-overlay';
      overlay.innerHTML = '<div class="loading-spinner"></div>';
      document.body.appendChild(overlay);
    }
    overlay.style.display = 'flex';
  }
  
  hideLoading() {
    const overlay = document.querySelector('.loading-overlay');
    if (overlay) {
      overlay.style.display = 'none';
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ShopPage();
});